<div class="dialog-pqr">
  <div class="header">
    <h2 mat-dialog-title>Valores do padrão de qualidade de referência - PQR</h2>
    <mat-dialog-actions>
      <button mat-dialog-close class="close-x-button">×</button>
    </mat-dialog-actions>
  </div>
  <mat-dialog-content>
    <h1 class="title">Tamanho das turmas</h1>
    <div class="panel">
      <app-tabela ngSkipHydration class="table-component" [cabecalhoCustomizado]="true">
        <ng-container cabecalho>
          <tr>
            <th class="table-header" rowspan="2" style="width: 40%">Etapa / Modalidade</th>
            <th class="table-header" colspan="2" style="width: 30%">Escolas URBANAS</th>
            <th class="table-header" colspan="2" style="width: 30%">Escolas de áreas RURAIS</th>
          </tr>
          <tr>

            <th class="table-header header-nowrap" style="width: 15%">Alunos por turma (Número Máximo)</th>
            <th class="table-header" style="width: 15%">Docentes por turma</th>
            <!-- Rurais -->
            <th class="table-header header-nowrap" style="width: 15%">Alunos por turma (Número Máximo)</th>
            <th class="table-header" style="width: 15%">Docentes por turma</th>
          </tr>
        </ng-container>
        <ng-container corpo>
          <tr *ngFor="let codEtapa of etapas">
            <!-- Etapa -->
            <td class="table-cell align-left">
              {{ obterDados(codEtapa, 1)?.etapaEnsino?.descricao || obterDados(codEtapa, 2)?.etapaEnsino?.descricao }}
            </td>
            
            <!-- URBANA : Alunos -->
            <td class="table-cell">
              <input
                [value]="obterDados(codEtapa, 1)?.qntAlunosTurma ?? '-'"
                class="display-input text-green"
                disabled="true"
                maxlength="2"
              />
            </td>
            <!-- URBANA - Docentes -->
            <td class="table-cell">
              <input
                [value]="obterDados(codEtapa, 1)?.qntDocentesTurma ?? '-'"
                class="display-input text-green"
                disabled="true"
                maxlength="2"
              />
            </td>
            
            <!-- RURAL - Alunos -->
            <td class="table-cell">
              <input
                [value]="obterDados(codEtapa, 2)?.qntAlunosTurma ?? '-'"
                class="display-input text-green"
                disabled="true"
                maxlength="2"
              />
            </td>
            <!-- RURAL - Docentes -->
            <td class="table-cell">
              <input
                [value]="obterDados(codEtapa, 2)?.qntDocentesTurma ?? '-'"
                class="display-input text-green"
                disabled="true"
                maxlength="2"
              />
            </td>
          </tr>
        </ng-container>
      </app-tabela>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="footer">
    <button class="close-button" mat-dialog-close>Fechar</button>
  </mat-dialog-actions>
</div>